import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import styles from './Lots.module.scss';
import SiteplanImgMapper from './siteplanImgMapper/siteplanImgMapper';
import { setShowAvailableLots } from '../../../../redux/siteplanManagement/action';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';

const Lots = (props) => {
	const { showAvailableLots, setShowAvailableLots, stayHighlighted } = props;
	var history = useHistory();
	const handleShowAvailableLots = (e) => {
		const data = e.target.checked;
		setShowAvailableLots(data);
	};
	useEffect(() => {
		console.log('this is the param', history);
	}, [history]);

	return (
		<div className={styles.lots}>
			<div className={styles.lots_header}>
				{history.location.state?.from !== 'Purchasers' && (
					<>
						<h3 className={styles.lots_title}>Lots</h3>

						<FormControlLabel
							className={styles.available_lots_checkbox}
							control={
								<Checkbox
									checked={showAvailableLots}
									onChange={handleShowAvailableLots}
									checkedIcon={
										<CheckBoxIcon
											className={styles.checkbox}
										/>
									}
								/>
							}
							label='Show available lots'
						/>
					</>
				)}
			</div>
			<SiteplanImgMapper stayHighlighted={stayHighlighted} />
		</div>
	);
};

const mapStateToProps = (state) => ({
	showAvailableLots: state.siteplanManagement.showAvailableLots,
});
export default connect(mapStateToProps, { setShowAvailableLots })(Lots);
